import {Component, OnInit} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {ResumenGraficos} from '../../../core/models/resumen.graficos.model';
import {environment} from '../../../../environments/environment';
import {ToastrService} from 'ngx-toastr';
import {UserService} from '../../../core/services/user.service';

@Component({
  selector: 'app-exportadores-otros',
  templateUrl: './exportadores-otros.component.html',
})
export class ExportadoresOtrosComponent implements OnInit {

  public HTTP_RESPONSE = environment.HTTP_RESPONSE;
  public isLoading = false;
  public listaExportadores: any[] = [];
  public filtros: any = {};

  constructor(
    private route: ActivatedRoute,
    private resumenGraficos: ResumenGraficos,
    private toastrService: ToastrService,
    public user: UserService
  ) {}

  ngOnInit(): void {
    this.route.queryParams.subscribe(params => {
      this.filtros = {
        local: params['local'] || '-1',
        month: params['month'] || '-1',
        year: params['year'] || new Date().getFullYear(),
        tipo: params['tipo'] || '1',
      };
      this.cargarExportadores();
    });
  }

  public cargarExportadores() {
    this.isLoading = true;
    this.resumenGraficos.getClasificacionClientesByOperador(this.filtros).then((response: any) => {
      if (response.tipo === this.HTTP_RESPONSE.SUCCESS) {
        this.listaExportadores = response.data;
      } else {
        this.toastrService.error('No se pudo obtener el listado de exportadores');
      }
      this.isLoading = false;
    });
  }

  public descargar() {
    const token = this.user.userToken;
    window.open(
      environment.CDN_BASE + 'api/reports/report.php?type=excel&page=operador_reporteclasificacionclientes&token=' +
      token + '&obj=' + JSON.stringify(this.filtros),
      '_blank'
    );
  }
}
